import React, { startTransition, useEffect } from "react";
import "./styles.css";
//internal and external components/containers import
import SearchFilterContainer from "../../containers/SearchFilterContainer";
import { Box, Typography, } from "@mui/material";
import EvaluationTabs from "../../containers/EvaluationTabs";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentEvaluationTab, setReportFoldersList, setStructuredReportFoldersList } from "../../redux/reducers/evaluation";
import { useTranslation } from "react-i18next";
import { getEvaluationReportFolders, getEvaluationReportList } from "../../api/reports";
import { ReportStatus, reportStatusName, ReportType, reportTypeName } from "../../api/types";
import { evaluationCriteriaActionsRegex, evaluationCriteriaEvidencesRegex, evaluationCriteriaRegex, evaluationCriterionRegex, evaluationSelectedCriteriaActionsRegex, evaluationSelectedStandardsActionsRegex, evaluationSelectedStandardsRegex, evaluationSelectedStandardsReportRegex, evaluationStandardsRegex, onsiteSelectedCriteriaRegex, onsiteSelectedSessionRegex, onsiteSelectedStandardRegex, onsiteSessionCriteriaRegex, onsiteSessionsRegex, onsiteSessionStandardsRegex } from "../../common/StaticExports";


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
function TabPanel(props: TabPanelProps) {
const { children, value, index, ...other } = props;

return (
    <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    className={"simpleTabPanel"}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
    >
    {value === index && (
        <Box sx={{ p: 2 }}>
        <Typography>{children}</Typography>
        </Box>
    )}
    </div>
);
}

const ClubsHomePage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const currentClub = useSelector((state:any) => state.clubDetails);
  const folderList: any = useSelector(
    (state: any) => state.evaluation.reportFolders
  );

  useEffect(() => {
    startTransition(() => {      
      var tab:any = "";
      var path = location.pathname;
      if (evaluationCriteriaRegex.test(location?.pathname) ||
          evaluationCriterionRegex.test(location?.pathname) ||
          evaluationStandardsRegex.test(location.pathname) ||
          evaluationSelectedStandardsRegex.test(location.pathname) ||
          evaluationSelectedStandardsReportRegex.test(location.pathname) ||
          evaluationCriteriaActionsRegex.test(location.pathname) ||
          evaluationSelectedCriteriaActionsRegex.test(location.pathname) ||
          evaluationCriteriaEvidencesRegex.test(location.pathname) ||
          evaluationSelectedStandardsActionsRegex.test(location.pathname)) {
        path = '/evaluation';
      } else if (
          onsiteSessionsRegex.test(location?.pathname) ||
          onsiteSelectedSessionRegex.test(location.pathname) ||
          onsiteSessionCriteriaRegex.test(location.pathname) ||
          onsiteSelectedCriteriaRegex.test(location.pathname) ||
          onsiteSessionStandardsRegex.test(location.pathname) ||
          onsiteSelectedStandardRegex.test(location.pathname)) {
        path = '/onsite';
      }
      switch(path) {
        case '/evaluation':
          tab = t("EVALUATION");
          dispatch(setCurrentEvaluationTab(tab));
          break;
        case '/onsite':
          tab = t("ON_SITE");
          dispatch(setCurrentEvaluationTab(tab));
          break;
        case '/reports':
          tab = t("REPORTS");
          dispatch(setCurrentEvaluationTab(tab));
          break;
      } 
    });
  }, [currentClub, location.pathname, dispatch, t]);

  function buildFolderStructure(folders: any, parentId: number | null) {
    const result: any = [];

    folders?.forEach((folder: any) => {
      if (folder?.parentFolderId === parentId) {
        const children = buildFolderStructure(folders, folder?.id);
        if (children.length) {
          result.push({
            ...folder,
            pathId: folder.id,
            children: children,
          });
        } else {
          result.push({ ...folder, pathId: folder.id });
        }
      }
    });

    return result;
  }
  
  const fetchReportFolderData = async () => {
    const foldersResponse = await getEvaluationReportFolders({
      clubId: currentClub?.id,
    });
    const reportListResponse = await getEvaluationReportList({
      clubId: currentClub?.id,
    });
    const sortedFolders:any = foldersResponse?.map((d:any) => {return {...d, type: 'folder'}});
    const evalReports:any = reportListResponse?.evaluationReports.map((d:any) => 
        {
            const parentFolder = foldersResponse?.find((fr:any) => fr.name == d.year);
            const typeIndex: ReportType = d.type;
            const statusIndex: ReportStatus = d.status;
            if (parentFolder != null) {
                if (d?.id == null) {
                    return {
                        ...d,
                        id: 'draft',
                        name: t(reportTypeName[typeIndex]) + ' '  + d.year + ' (' + t(reportStatusName[statusIndex]) + ')', 
                        type: 'file',
                        parentFolderId: parentFolder.id,
                    }
                }
                return {
                    ...d,
                    name: t(reportTypeName[typeIndex]) + ' '  + d.year + ' (' + t(reportStatusName[statusIndex]) + ')', 
                    type: 'file',
                    parentFolderId: parentFolder.id,
                }
            }
        });
    const finalFolders:any = [...(sortedFolders ?? []), ...(evalReports ?? [])];
    dispatch(setReportFoldersList(finalFolders));
    if (finalFolders?.length > 0) {
      const folderStruct: any = buildFolderStructure(finalFolders, null);
      dispatch(setStructuredReportFoldersList(folderStruct));
    }
  };

  useEffect(() => {
    currentClub && currentClub?.id && !folderList &&
    fetchReportFolderData();
  })

    return(
        <React.Fragment>
            <Box className={'contentSpacing'}>
                <Box className='headerWrapper'>
                  <SearchFilterContainer parent={'evaluation'} />
                </Box>
                <EvaluationTabs />
            </Box>
        </React.Fragment>
    )
}

export default ClubsHomePage;